import type { InjectionKey } from 'vue';
import { ref, computed } from 'vue';
import { valuesRouteTransfer } from './routeTransfer.constant';
import type { TransactionPayload, PreTransactionResponse } from '@/types/TransactionType';
import type { QuoteResponse, TypeCoupon, RequoteDetails } from '@/types/QuoteType';
import type { WalletType } from '@/types/WalletType';
import type { Destinatary } from '@/types/DestinataryType';
import type { PurposeComexInfo } from '../types/comex.type';
import type { TypeTransactionPurpose } from '@/types/TypeTransactionPurpose';
import type { IDestinataryP2P } from '@/types/InterfaceDestinatary';
// eslint-disable-next-line local-rules/architecture-boundaries -- deuda preexistente (BMB-4178): promover a src/shared/ lo que transaction consume de contacts y scheduledTransfer
import type { TransferFlowQueryParams } from '@/modules/contacts/types/contactList.type';
import type { TransactionProvider } from '../types/transactionProvider.type';

export const initialValuesTransactionProvider: TransactionProvider = {
  contactTransactionflowConfig: ref({
    beneficiary: 0,
    type: undefined,
  } as TransferFlowQueryParams),
  isCCA: ref(false),
  isACH: ref(false),
  isSedpe: computed(() => false),
  isOriginSecondaryAccount: computed(() => false),
  isComexFlow: ref(false),
  isComexAvailable: computed(() => false),
  isBrazilPix: computed(() => false),
  originRoute: ref(valuesRouteTransfer),
  originWallet: ref({} as WalletType),
  destinationWallet: ref({} as WalletType),
  destinationRoute: ref(valuesRouteTransfer),
  isNational: ref(false),
  isP2P: ref(false),
  isStablecoin: ref(false),
  selectedDestinyBankId: ref(null),
  selectedDestinyBankCode: ref(''),
  isScheduled: ref(false),
  navigateTo: () => undefined,
  quoteData: ref({} as RequoteDetails),
  quoteResponse: ref({} as QuoteResponse),
  updateQuoteData: () => undefined,
  updateQuoteResponse: () => undefined,
  coupon: ref({} as TypeCoupon),
  transactionPayload: ref({} as TransactionPayload),
  updateTransactionPayload: () => undefined,
  selectedContact: ref({} as Destinatary),
  selectedContactP2P: ref({} as IDestinataryP2P),
  preTransactionResponse: ref({} as PreTransactionResponse),
  updatePreTransactionResponse: () => undefined,
  selectedPurposesComex: ref({} as PurposeComexInfo),
  updateSelectPurposesComex: () => undefined,
  purposeSelected: ref({} as TypeTransactionPurpose),
  updateSelectPurpose: () => undefined,
  pendingDocumentFiles: ref([]),
  updatePendingDocumentFiles: () => undefined,
};

export const transactionProviderKey: InjectionKey<TransactionProvider> =
  Symbol('transaction');
